<template>
  <div class="modal-content-account">
    <div class="modal-header">
      <h2>Izmena računa</h2>
    </div>
    <div class="body">
      <form action="post">
        <div id="first-section">
          <label class="col-form-label col-form-label-lg">Matični broj</label>
          <input
            class="form-control"
            rows="4"
            :class="{
              'border-red': errorLog.mb
            }"
            placeholder="Unesite matični broj"
            v-model.trim="modalAccountDetails.mb"
            @focus="clearError(['mb'])"
          />
          <label class="col-form-label col-form-label-lg">PIB</label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite pib"
            :class="{
              'border-red': errorLog.pib
            }"
            v-model.trim="modalAccountDetails.pib"
            @focus="clearError(['pib'])"
          />
          <label class="col-form-label col-form-label-lg"
            >Broj tekućeg računa</label
          >
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite broj računa"
            :class="{
              'border-red': errorLog.account || errorLog.cleanAccount
            }"
            v-model.trim="modalAccountDetails.account"
            @focus="clearError(['account', 'cleanAccount'])"
            v-on:blur="onAccountBlur"
            @input="fetchBank"
          />
          <label class="col-form-label col-form-label-lg">
            Naziv banke
            <i
              class="fas fa-info-circle explanation-tooltip"
              title="Dobija se na osnovu broja računa"
            ></i>
          </label>
          <input
            class="form-control"
            rows="4"
            disabled
            :class="{
              'border-red': errorLog.bank
            }"
            placeholder="Nepoznat kod banke"
            v-model.trim="modalAccountDetails.bank"
          />
        </div>
      </form>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorMessage.length > 0">
            {{ errorMessage }}
          </p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="editAccount"
          :disabled="loading"
        >
          <span v-if="!loading">Izmeni</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import BigNumber from 'bignumber.js';
export default {
  created() {
    Object.assign(this.modalAccountDetails, {
      pib: this.accountDetails.pib,
      mb: this.accountDetails.mb,
      account: this.accountDetails.account,
      bank: this.accountDetails.bank,
      cleanAccount: this.accountDetails.account
    });
    if (this.modalAccountDetails.account === '/') {
      this.modalAccountDetails.account = '';
    } else {
      this.fetchBank();
    }
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      timer: null,
      modalAccountDetails: {
        pib: '',
        cleanAccount: '',
        mb: '',
        account: '',
        bank: ''
      },
      fieldNames: {
        pib: 'PIB',
        cleanAccount: 'broj računa',
        mb: 'matični broj',
        account: 'broj računa',
        bank: 'naziv banke'
      },
      errorLog: {
        pib: false,
        cleanAccount: false,
        mb: false,
        account: false,
        bank: false
      }
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('finances', ['accountDetails'])
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('finances', ['updateAccount']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    fetchBank() {
      //clearing account number of -
      this.modalAccountDetails.cleanAccount = this.modalAccountDetails.account.replace(
        /-/g,
        ''
      );

      //proceed
      if (this.modalAccountDetails.cleanAccount.length < 3) {
        return;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(
        function() {
          const bankCode = this.modalAccountDetails.cleanAccount.substring(
            0,
            3
          );
          this.modalAccountDetails.bank = utilService.getBankNameByCode(
            bankCode
          );
        }.bind(this),
        700
      );
    },
    onAccountBlur() {
      const accountNumber = this.modalAccountDetails.account;
      const accountSepparated = accountNumber.split('-');
      if (accountSepparated.length != 3) {
        return;
      }
      const middleNumber = accountSepparated[1].padStart(13, '0');
      this.modalAccountDetails.account = `${
        accountSepparated[0]
      }-${middleNumber}-${accountSepparated[2]}`;
      this.fetchBank();
    },
    editAccount() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loadingStarted();
      let editAccountData = {
        bank: this.modalAccountDetails.bank,
        account: this.modalAccountDetails.account,
        pib: this.modalAccountDetails.pib,
        mb: this.modalAccountDetails.mb
      };

      financesInstance
        .put(
          `communities/${this.$store.getters.getActiveCommunity.id}/account`,
          editAccountData
        )
        .then(() => {
          this.updateAccount(this.modalAccountDetails);
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          console.log(error);
          this.showFailModal();
          this.loadingFinished();
        });
    },
    validateInput() {
      return (
        !this.areFieldsEmpty() &&
        this.validateMb() &&
        this.validatePib() &&
        this.validateAccount()
      );
    },
    validatePib() {
      if (!this.modalAccountDetails.pib || this.modalAccountDetails.pib == '') {
        return true;
      }
      return (
        !this.fieldContainsLetters('pib') &&
        this.validateFieldLength('pib', 9) &&
        this.validateFieldRange('pib', 100000001, 999999999) &&
        this.validateIso7064v10('pib')
      );
    },
    validateAccount() {
      if (
        !this.modalAccountDetails.account ||
        this.modalAccountDetails.account == ''
      ) {
        this.modalAccountDetails.bank = '';
        return true;
      }
      return (
        !this.fieldContainsLetters('cleanAccount') &&
        this.validateFieldLength('cleanAccount', 18) &&
        this.validateIso7064v97('cleanAccount')
      );
    },
    validateIso7064v97(field) {
      const accNumber = this.modalAccountDetails[field].substring(
        0,
        this.modalAccountDetails[field].length - 2
      );
      const checkNum = this.modalAccountDetails[field].substring(
        this.modalAccountDetails[field].length - 2,
        this.modalAccountDetails[field].length
      );

      const bigAccNum = new BigNumber(accNumber * 100);

      const calculatedCheckDigit = 98 - bigAccNum.modulo(97);

      const correct = checkNum == calculatedCheckDigit;

      if (!correct) {
        this.errorLog[field] = true;

        this.printError(
          `Uneta vrednost za polje ${this.fieldNames[field]} je neispravna`
        );
      }
      return correct;
    },
    validateIso7064v10(field) {
      let fullString = this.modalAccountDetails[field];
      let mod = 11;
      let sumDigit = 10;
      let checkDigitsLength = 1;

      const checkDigit = parseInt(
        fullString.substring(
          fullString.length - checkDigitsLength,
          fullString.length
        )
      );

      const string = fullString.substring(
        0,
        fullString.length - checkDigitsLength
      );

      let subtotal = 0;
      let sum = 0;
      let rest = 0;

      for (let i = 0; i < string.length; i++) {
        if (i == 0) {
          sum = parseInt(string[i]) + sumDigit;
        } else {
          sum = parseInt(string[i]) + rest;
        }

        subtotal = sum % sumDigit;

        if (subtotal == 0) {
          subtotal = 10;
        }

        rest = (subtotal * 2) % mod;
      }
      let pibCorrect = null;
      if (rest == 1) {
        pibCorrect = checkDigit == 0;
      } else {
        pibCorrect = mod - rest == checkDigit;
      }

      if (!pibCorrect) {
        this.errorLog[field] = true;
        this.printError(
          `Uneta vrednost za polje ${this.fieldNames[field]} je neispravna`
        );
      }
      return pibCorrect;
    },
    validateMb() {
      if (!this.modalAccountDetails.mb || this.modalAccountDetails.mb == '') {
        return true;
      }
      return (
        !this.fieldContainsLetters('mb') && this.validateFieldLength('mb', 8)
      );
    },
    validateFieldRange(field, min, max) {
      const between =
        this.modalAccountDetails[field] >= min &&
        this.modalAccountDetails[field] <= max;
      if (!between) {
        this.errorLog[field] = true;
        this.printError(
          `Polje ${
            this.fieldNames[field]
          } je mora biti u granicama (${min}-${max}).`
        );
      }
      return between;
    },
    validateFieldLength(field, length) {
      const equal = this.modalAccountDetails[field].length == length;
      if (!equal) {
        this.errorLog[field] = true;
        this.printError(
          `Polje ${this.fieldNames[field]} nije propisane dužine (${length}).`
        );
      }
      return equal;
    },
    fieldContainsLetters(field) {
      // null undefined -> returns true
      const contains = /[a-zA-Z]/.test(this.modalAccountDetails[field]);
      if (contains) {
        this.errorLog[field] = true;
        this.printError(
          `Polje ${this.fieldNames[field]} ne sme sadržati slova.`
        );
      }
      return contains;
    },
    areFieldsEmpty() {
      for (let field of Object.keys(this.modalAccountDetails)) {
        if (this.modalAccountDetails[field] == '') {
          this.errorLog[field] = true;
          this.printError(
            `Polje ${this.fieldNames[field]} ne sme biti prazno.`
          );
          return true;
        }
      }
      return false;
    },
    clearError(fields) {
      for (let field of fields) {
        this.errorLog[field] = false;
        this.errorMessage = '';
      }
    },
    printError(text) {
      this.errorMessage = text;
    }
  }
};
</script>

<style lang="scss">
.modal-content-account {
  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    max-width: 400px;
  }

  .err-msg {
    text-align: left;
    color: red;
  }

  .border-red {
    border-color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .explanation-tooltip {
    color: rgba(0, 0, 0, 0.521);
    font-size: 1rem;
    vertical-align: top;
  }

  .explanation-tooltip:hover {
    color: rgb(245, 163, 13);
  }
}
</style>
